import {
  RESULTS_RECEIVED,
  RESTAURANT_HOVER,
  RESTAURANT_UNHOVER,
  RESTAURANT_SELECT,
  RESTAURANT_UNSELECT,
  RESULTS_UPDATE,
  RESTAURANT_DELETE,
  NO_DATA,
  START_AD_HOC_SEARCH,
  ADD_AD_HOC_RESTAURANT,
  SET_AD_HOC_SEARCH_STATUS,
  PROMPT_FOR_MORE_BATCHES,
  STOP_AD_HOC_SEARCH,
  AD_HOC_SEARCH_COMPLETE,
  CLEAR_AD_HOC_RESULTS,
} from "../actions/types";

const initialState = {
  restaurants: [],
  adHocSearchActive: false,
  adHocSearchJobId: null,
  adHocSearchLocation: null,
  adHocRestaurantsProcessed: 0,
  adHocTotalRestaurants: 0,
  adHocVeganResultsFound: 0,
  adHocPromptForMore: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESULTS_UPDATE:
    case RESULTS_RECEIVED:
      return {
        ...state,
        restaurants: payload,
        // Clear noData when results arrive — fixes race condition where
        // a stale fetch (without keyword) sets noData:true before the
        // real fetch (with keyword) returns actual results.
        ...(payload.length > 0 ? { noData: false } : {}),
      };
    case RESTAURANT_DELETE:
      console.log(payload);
      console.log(state);
      const restaurants = state.restaurants.filter(
        (restaurant) => restaurant._id !== payload
      );
      return { ...state, restaurants };

    case RESTAURANT_HOVER:
      return { ...state, hover: payload };
    case RESTAURANT_UNHOVER:
      return { ...state, hover: null };
    case RESTAURANT_SELECT:
      return { ...state, selected: payload.id, source: payload.source };
    case RESTAURANT_UNSELECT:
      return { ...state, selected: null };
    case NO_DATA:
      return { ...state, noData: payload };

    case START_AD_HOC_SEARCH:
      return {
        ...state,
        adHocSearchActive: true,
        adHocSearchJobId: payload.jobId,
        adHocSearchLocation: payload.location,
        adHocRestaurantsProcessed: 0,
        adHocTotalRestaurants: 20, // Always show "x of 20"
        adHocVeganResultsFound: 0,
        adHocPromptForMore: false,
      };

    case ADD_AD_HOC_RESTAURANT:
      // Add ad hoc restaurant to existing results (don't replace)
      // Check if restaurant already exists (by temporary _id or googleId)
      const existingIndex = state.restaurants.findIndex(
        (r) =>
          r._id === payload._id ||
          (payload.googleId && r.googleId === payload.googleId)
      );

      if (existingIndex >= 0) {
        // Restaurant already exists, don't add duplicate
        return state;
      }

      return {
        ...state,
        restaurants: [...state.restaurants, payload],
        adHocVeganResultsFound: state.adHocVeganResultsFound + 1,
      };

    case SET_AD_HOC_SEARCH_STATUS:
      return {
        ...state,
        adHocSearchJobId: payload.jobId || state.adHocSearchJobId,
        adHocRestaurantsProcessed:
          payload.restaurantsProcessed !== undefined
            ? payload.restaurantsProcessed
            : state.adHocRestaurantsProcessed,
        adHocTotalRestaurants:
          payload.totalRestaurants !== undefined
            ? payload.totalRestaurants
            : (state.adHocTotalRestaurants || 20), // Default to 20 if not set, but can go higher
        adHocVeganResultsFound:
          payload.veganResultsFound !== undefined
            ? payload.veganResultsFound
            : state.adHocVeganResultsFound,
        adHocSearchActive:
          payload.status === "in_progress" ||
          payload.status === "processing"
            ? true
            : payload.status === "completed" || payload.status === "failed" || payload.status === "cancelled"
            ? false
            : state.adHocSearchActive,
      };

    case PROMPT_FOR_MORE_BATCHES:
      return {
        ...state,
        adHocPromptForMore: true,
      };

    case STOP_AD_HOC_SEARCH:
      return {
        ...state,
        adHocSearchActive: false,
        adHocPromptForMore: false,
      };

    case AD_HOC_SEARCH_COMPLETE:
      return {
        ...state,
        adHocSearchActive: false,
        adHocPromptForMore: false,
        adHocRestaurantsProcessed:
          payload.totalProcessed || state.adHocRestaurantsProcessed,
        adHocTotalRestaurants:
          payload.totalRestaurants !== undefined
            ? payload.totalRestaurants
            : state.adHocTotalRestaurants,
        adHocVeganResultsFound:
          payload.veganResultsFound || state.adHocVeganResultsFound,
      };

    case CLEAR_AD_HOC_RESULTS:
      return {
        ...state,
        adHocSearchActive: false,
        adHocSearchJobId: null,
        adHocSearchLocation: null,
        adHocRestaurantsProcessed: 0,
        adHocTotalRestaurants: 0,
        adHocVeganResultsFound: 0,
        adHocPromptForMore: false,
      };

    default:
      return state;
  }
}
